import { Icon, IconButton } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import styled from 'styled-components';

const OptionContainer = styled.div`
  align-items: center;
  border-radius: var(--radius-m);
  color: var(--color-neutral-800);
  display: flex;
  height: 26px;
  justify-content: space-between;
  width: 100%;
`;

const CustomOption = ({ children, ...props }) => {
  return (
    <components.Option {...props}>
      <OptionContainer>
        {children}
        {props.isSelected ? (
          <Icon name="success" size="lg" color="var(--color-accent-primary-default)" />
        ) : (
          <IconButton
            variant="text"
            onClick={e => {
              e.stopPropagation();
              if (props.selectProps.onClickOptionEndButton) {
                props.selectProps.onClickOptionEndButton(props.data.value);
              }
            }}
          >
            <Icon name="edit" size="md" color="var(--color-accent-primary-default)" />
          </IconButton>
        )}
      </OptionContainer>
    </components.Option>
  );
};

CustomOption.propTypes = {
  children: PropTypes.node,
  props: PropTypes.shape({
    isSelected: PropTypes.bool,
    selectProps: PropTypes.shape({
      onClickOptionEndButton: PropTypes.func
    }),
    data: PropTypes.shape({
      value: PropTypes.any
    })
  })
};

export { CustomOption };
